import React from 'react'

import * as S from './styles'

/**
 * @typedef {'unstyled' | 'filled' | 'default'} InputVariant
 */

/**
 * @typedef {Object} NumberInputProps
 * @property {string} [placeholder]
 * @property {React.ReactNode} [label]
 * @property {InputVariant} [variant]
 * @property {(value: number | "") => void} [onChange]
 * @property {number | ""} [value]
 * @property {boolean} [hideControls]
 * @property {number | null} [defaultValue]
 * @property {boolean} [disabled]
 * @property {boolean} [withAsterisk]
 */

/**
 * @param {NumberInputProps} props
 */
export default function NumberInput({
  placeholder,
  label,
  variant = 'filled',
  onChange,
  value,
  hideControls = true,
  defaultValue = null,
  disabled = false,
  withAsterisk = false
}) {
  return (
    <S.NumberInput
      withAsterisk={withAsterisk}
      placeholder={placeholder}
      defaultValue={defaultValue}
      label={label}
      variant={variant}
      radius="xl"
      value={value}
      onChange={onChange}
      disabled={disabled}
      hideControls={hideControls}
    />
  )
}
